const OWNER_ACCESS_TOKEN_STORAGE_KEY = "caseflow_owner_access_token";

export const getOwnerAccessToken = (): string | null => {
  if (typeof window === "undefined") return null;
  const raw = window.sessionStorage.getItem(OWNER_ACCESS_TOKEN_STORAGE_KEY);
  const token = raw?.trim() ?? "";
  return token ? token : null;
};

export const setOwnerAccessToken = (token: string): void => {
  if (typeof window === "undefined") return;
  const normalized = token.trim();
  if (!normalized) {
    window.sessionStorage.removeItem(OWNER_ACCESS_TOKEN_STORAGE_KEY);
    return;
  }
  window.sessionStorage.setItem(OWNER_ACCESS_TOKEN_STORAGE_KEY, normalized);
};

export const clearOwnerAccessToken = (): void => {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(OWNER_ACCESS_TOKEN_STORAGE_KEY);
};
